<template>
  <v-container>
    <v-data-table
      disable-sort
      :loading="loading"
      :headers="headers"
      :items="expenses"
      class="elevation-1"
      :items-per-page="40"
      :footer-props="{
        itemsPerPageText: 'Itens por pagina',
        itemsPerPageOptions: [15, 20, 40],
        showFirstLastPage: true,
      }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Despesas Pagas</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :disabled="loadingRefresh"
                :loading="loadingRefresh"
                @click="updateExpenses()"
                fab
                small
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-refresh </v-icon>
              </v-btn>
            </template>
            <span>Sincronizar Despesas Pagas</span>
          </v-tooltip>

          <v-row>
            <v-col cols="4">
              <v-select
                :items="chess_gestao_cost_centers"
                v-model="chess_gestao_cost_center"
                class="mt-7 ml-6"
                label="Centro de Custo"
                item-text="text"
                item-value="id"
                dense
                outlined
                rounded
                clearable
              ></v-select>
            </v-col>
            <v-col cols="4">
              <v-select
                :items="months"
                v-model="month"
                class="mt-7"
                label="Mês"
                dense
                outlined
                rounded
              ></v-select>
            </v-col>
            <v-col cols="4">
              <v-select
                :items="years"
                v-model="year"
                class="mt-7 mr-4"
                label="Ano"
                dense
                outlined
                rounded
              ></v-select>
            </v-col>
          </v-row>

          <v-btn @click="initialize()" rounded color="primary"> aplicar</v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.id="{ item }">
        <v-row>
          <v-col style="font-size: 10px">
            {{ item.id }}
          </v-col>
        </v-row>
      </template>
      <template v-slot:item.fiscal_note="{ item }">
        <v-row>
          <v-col style="font-size: 10px" class="text-center">
            {{ item.fiscal_note }}
          </v-col>
        </v-row>
      </template>
      <template v-slot:item.supplier="{ item }">
        <v-row>
          <v-col style="font-size: 10px">
            {{ formatSupplier(item) }}
          </v-col>
        </v-row>
      </template>
      <template v-slot:item.cost_center="{ item }">
        <v-row>
          <v-col style="font-size: 10px">
            {{ formatCostCenter(item) }}
          </v-col>
        </v-row>
      </template>

      <template v-slot:item.chart_of_accounts="{ item }">
        <v-row>
          <v-col style="font-size: 10px">
            {{ formatChartOfAccounts(item) }}
          </v-col>
        </v-row>
      </template>

      <template v-slot:item.account="{ item }">
        <v-row>
          <v-col style="font-size: 10px" class="text-center">
            {{ formatAccount(item) }}
          </v-col>
        </v-row>
      </template>
      <template v-slot:item.pay_day="{ item }">
        <v-row>
          <v-col style="font-size: 10px">
            {{ formatDate(item.payDay) }}
          </v-col>
        </v-row>
      </template>
      <template v-slot:item.value="{ item }">
        <v-row>
          <v-col style="font-size: 10px" class="text-right">
            {{ formatMoney(item.totalAmount) }}
          </v-col>
        </v-row>
      </template>

      <template v-slot:footer>
        <v-row justify="end" class="pa-4">
          <v-col class="text-right" cols="" style="background: #e0e0e0">
            <strong class="text-right mr-12">
              TOTAL:
              {{
                expenses
                  .reduce((sum, item) => sum + parseFloat(item.totalAmount || 0), 0)
                  .toLocaleString("pt-br", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
              }}
            </strong>
          </v-col>
        </v-row>
      </template>

      <template v-slot:item.approved="{ item }">
        <v-switch
          dense
          v-model="item.viewed"
          :true-value="1"
          false-value=""
          color="primary"
          hide-details
          :disabled="true"
        ></v-switch>
      </template>

      <template v-slot:item.conference="{ item }">
        <v-switch
          v-model="item.conference"
          dense
          :true-value="1"
          false-value=""
          :disabled="true"
          color="primary"
          hide-details
        ></v-switch>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      chess_gestao_cost_center: null,
      chess_gestao_cost_centers: [],
      Sfalse: false,
      Strue: true,
      loading: false,
      loadingRefresh: false,
      headers: [
        { text: "#", value: "id", align: "start", sortable: false },
        { text: "FORNECEDOR", value: "supplier" },
        { text: "CENTRO DE CUSTO", value: "cost_center" },
        { text: "PLANO DE CONTAS", value: "chart_of_accounts" },
        { text: "DOCUMENTO", value: "fiscal_note", align: "center" },
        { text: "CONTA", value: "account", align: "center" },
        { text: "DATA", value: "pay_day" },
        { text: "VALOR", value: "value" },
        { text: "APROVADO", value: "approved" },
        { text: "CONCILIADO", value: "conference" },
      ],
      expenses: [],
      months: [
        { text: "Janeiro", value: 1 },
        { text: "Fevereiro", value: 2 },
        { text: "Março", value: 3 },
        { text: "Abril", value: 4 },
        { text: "Maio", value: 5 },
        { text: "Junho", value: 6 },
        { text: "Julho", value: 7 },
        { text: "Agosto", value: 8 },
        { text: "Setembro", value: 9 },
        { text: "Outubro", value: 10 },
        { text: "Novembro", value: 11 },
        { text: "Dezembro", value: 12 },
      ],
      month: 1,
      year: 2000,
    };
  },

  created() {
    // Pega os parâmetros mês e ano da rota, se existirem
    if (this.$route && this.$route.params) {
      if (this.$route.params.month) {
        this.month = parseInt(this.$route.params.month);
      }
      if (this.$route.params.year) {
        this.year = parseInt(this.$route.params.year);
      }

      if (this.$route.params.chess_gestao_cost_center) {
        this.chess_gestao_cost_center = parseInt(this.$route.params.chess_gestao_cost_center);
        
      }
    } else {
      //set o mes atual
      const now = new Date();
      this.month = now.getMonth() + 1;

      //set o ano atual
      this.year = now.getFullYear();
    }

    this.initialize();
  },
  computed: {
    years() {
      let years = [];
      for (let year = 2000; year <= 2040; year++) {
        years.push(year);
      }
      return years;
    },
  },
  methods: {
    ...mapActions("ExpensePaid", ["indexDetails", "update", "getChessGestaoCostCenter"]),
    initialize() {
      //carrega os centros de custo
      this.getChessGestaoCostCenter()
        .then((response) => {
          this.chess_gestao_cost_centers = response.data;
        })
        .finally();
      console.log(this.chess_gestao_cost_center);
      //carrega as depesas pagas
      this.loading = true;
      let data = {
        chess_gestao_cost_center: this.chess_gestao_cost_center,
        month: this.month,
        year: this.year,
      };
      this.indexDetails(data)
        .then((response) => {
          this.expenses = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateExpenses() {
      this.loadingRefresh = true;
      this.update()
        .then(() => {
          this.initialize();
          this.$toast.success("Atualizado");
        })
        .finally(() => {
          this.loadingRefresh = false;
        });
    },
    formatSupplier(item) {
      let supplier = JSON.parse(item.supplier);
      return supplier.fantasy_name;
    },
    formatCostCenter(item) {
      let cost_centers = JSON.parse(item.cost_centers);
      let cost_center_names = [];
      cost_centers.forEach((item) => {
        cost_center_names.push(item.code + " - " + item.name);
      });

      return cost_center_names.join();
    },
    formatChartOfAccounts(item) {
      let chart_of_accounts = JSON.parse(item.chart_of_accounts);
      let chart_of_account_names = [];
      chart_of_accounts.forEach((item) => {
        chart_of_account_names.push(
          item.group.classification_chart_accounts.code +
            "-" +
            item.group.code +
            "-" +
            item.code +
            " - " +
            item.name
        );
      });

      return chart_of_account_names.join();
    },
    formatAccount(item) {
      let accounts = JSON.parse(item.account);

      return accounts.description;
    },
    formatMoney(number) {
      number = this.parseNumber(number);
      return number.toLocaleString("pt-br", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    parseNumber(number) {
      if (isNaN(number)) {
        return 0;
      }
      let result = parseFloat(number);
      return result;
    },
    formatDate(date) {
      let date_split = date.split("-");
      return date_split[2] + "/" + date_split[1] + "/" + date_split[0];
    },
    approved() {
      return true;
    },
  },
};
</script>
